import React__default from 'react';
import { useConfiguratorContext } from '@grandvisionhq/configurator';
import { useDispatch, useSelector } from '@grandvisionhq/state';
import PrescriptionValidationStep from './PrescriptionValidationStep.js';
import { getFrameSku, getAdditionalPrescriptionInfoFormState, getVerificationAllowed } from '../../../state/configurator/selectors.js';
import { updatePrescriptionInfo, updateVerificationAllowed } from '../../../state/configurations/actions.js';

const PrescriptionValidationStepContainer = ()=>{
    const dispatch = useDispatch();
    const { goToNextStep , hasAttemptedNextStep  } = useConfiguratorContext();
    const frameSku = useSelector(getFrameSku);
    const prescriptionInfoFormState = useSelector(getAdditionalPrescriptionInfoFormState);
    const isVerificationAllowed = useSelector(getVerificationAllowed);
    const handleChange = React__default.useCallback((formState)=>{
        if (!frameSku) {
            return;
        }
        dispatch(updatePrescriptionInfo({
            frameSku,
            value: formState
        }));
    }, [
        frameSku,
        dispatch
    ]);
    const handleIsVerificationAllowedChange = React__default.useCallback((verificationAllowed)=>{
        if (!frameSku) {
            return;
        }
        dispatch(updateVerificationAllowed({
            frameSku,
            value: verificationAllowed
        }));
    }, [
        frameSku,
        dispatch
    ]);
    return /*#__PURE__*/ React__default.createElement(PrescriptionValidationStep, {
        prescriptionInfoFormState: prescriptionInfoFormState,
        verificationAllowed: isVerificationAllowed,
        onVerificationAllowedChange: handleIsVerificationAllowedChange,
        showValidationError: hasAttemptedNextStep,
        onChange: handleChange,
        onSubmit: goToNextStep
    });
};

export { PrescriptionValidationStepContainer };
//# sourceMappingURL=PrescriptionValidationStepContainer.js.map
